import type { BookInfo, BookSetting } from '@libs/domain';
import type { DepreciationMethod } from '@libs/enums';
import { depreciationMethod } from '@libs/enums';
import type { OrEmpty } from '@ps-smart-cp/ppfw-client';
import type { UsedBook } from '../context';

class BookDetail
  implements Pick<BookSetting['schema'], 'key'>, Pick<BookInfo['schema'], 'depreciationMethod'>
{
  private constructor(
    readonly key: number,
    readonly depreciationMethod: OrEmpty<DepreciationMethod>,
  ) {}

  static init({ key }: UsedBook) {
    return new BookDetail(key, '');
  }

  static fromRaw(raw: BookDetailRaw) {
    return new BookDetail(raw.key, depreciationMethod.toEnum(raw.depreciationMethod));
  }

  static fromRaws(raws: BookDetailRaw[]) {
    return raws.map(BookDetail.fromRaw);
  }
}

class BookDetailRaw
  implements Pick<BookSetting['record'], 'key'>, Pick<BookInfo['record'], 'depreciationMethod'>
{
  private constructor(
    readonly key: number,
    readonly depreciationMethod: string,
  ) {}

  static fromModel({ key, depreciationMethod }: BookDetail) {
    return new BookDetailRaw(key, depreciationMethod);
  }

  static fromModels(models: BookDetail[]) {
    return models.map(BookDetailRaw.fromModel);
  }
}

export { BookDetail, BookDetailRaw };
